/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Stats_DofollowInputs */

const en_directory_external_directories_stats_dofollow = /** @type {(inputs: Directory_External_Directories_Stats_DofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow sources`)
};

const zh_directory_external_directories_stats_dofollow = /** @type {(inputs: Directory_External_Directories_Stats_DofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow 来源`)
};

/**
* | output |
* | --- |
* | "Dofollow sources" |
*
* @param {Directory_External_Directories_Stats_DofollowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_stats_dofollow = /** @type {((inputs?: Directory_External_Directories_Stats_DofollowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Stats_DofollowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_stats_dofollow(inputs)
	return zh_directory_external_directories_stats_dofollow(inputs)
});
export { directory_external_directories_stats_dofollow as "directory.external_directories.stats_dofollow" }